import { MessageType } from "../store/types";
import { tryParse } from "./object";

/**
 * 检查文件名是否为图片类型
 * @param {string} fileName 文件名（可包含路径）
 * @returns {boolean} 是否为图片
 */
export function isImageFile(fileName: string): boolean {
  // 支持的图片扩展名列表（全小写）
  const imageExtensions = [
    "jpg",
    "jpeg",
    "png",
    "gif",
    "bmp",
    "webp",
    "tiff",
    "svg",
    "ico",
    "jfif",
  ];

  // 处理空值
  if (!fileName || typeof fileName !== "string") return false;

  // 提取扩展名
  const lastDotIndex = fileName.lastIndexOf(".");
  if (lastDotIndex === -1 || lastDotIndex === fileName.length - 1) {
    return false; // 无扩展名或点号在末尾
  }

  // 获取扩展名并转为小写
  const extension = fileName.slice(lastDotIndex + 1).toLowerCase();

  return imageExtensions.includes(extension);
}

/**
 * 检查文件名是否为视频类型
 * @param {string} fileName 文件名（可包含路径）
 * @returns {boolean} 是否为视频文件
 */
export function isVideoFile(fileName: string): boolean {
  // 支持的视频扩展名列表（全小写）
  const videoExtensions = [
    "mp4",
    "avi",
    "mov",
    "wmv",
    "flv",
    "mkv",
    "webm",
    "mpeg",
    "mpg",
    "m4v",
    "3gp",
    "ogv",
    "ts",
    "m2ts",
    "hevc",
  ];

  // 处理空值
  if (!fileName || typeof fileName !== "string") return false;

  // 清除可能的URL参数
  const cleanName = fileName.split("?")[0];

  // 提取扩展名
  const lastDotIndex = cleanName.lastIndexOf(".");
  if (lastDotIndex === -1 || lastDotIndex === cleanName.length - 1) {
    return false; // 无扩展名或点号在末尾
  }

  // 获取扩展名并转为小写
  const extension = cleanName.slice(lastDotIndex + 1).toLowerCase();

  return videoExtensions.includes(extension);
}

/**
 * 检查文件名是否为音频类型
 * @param {string} fileName 文件名（可包含路径）
 * @returns {boolean} 是否为音频文件
 */
export function isAudioFile(fileName: string): boolean {
  // 支持的音频扩展名列表（全小写）
  const audioExtensions = [
    "mp3",
    "wav",
    "ogg",
    "aac",
    "flac",
    "m4a",
    "wma",
    "aiff",
    "opus",
    "amr",
    "mid",
    "midi",
    "aif",
    "aifc",
    "mka",
    "ra",
    "rm",
    "alac",
    "ac3",
    "dsd",
    "pcm",
    "wv",
    "m4b",
    "m4p",
    "aax",
  ];

  // 处理空值
  if (!fileName || typeof fileName !== "string") return false;

  // 清除可能的URL参数
  const cleanName = fileName.split("?")[0];

  // 提取扩展名
  const lastDotIndex = cleanName.lastIndexOf(".");
  if (lastDotIndex === -1 || lastDotIndex === cleanName.length - 1) {
    return false; // 无扩展名或点号在末尾
  }

  // 获取扩展名并转为小写
  const extension = cleanName.slice(lastDotIndex + 1).toLowerCase();

  return audioExtensions.includes(extension);
}

export const parseFileData = (str: string) => {
  return tryParse(str);
};

export const getFileType = (fileName: string) => {
  const isImage = isImageFile(fileName);
  const isVideo = isVideoFile(fileName);
  const isAudio = isAudioFile(fileName);
  let type = MessageType.File;
  if (isImage || isVideo || isAudio) {
    if (isVideo) {
      type = MessageType.Video;
    }
    if (isAudio) {
      type = MessageType.Audio;
    }
    if (isImage) {
      type = MessageType.Image;
    }
  }
  return type;
};
